



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// ADDSTAKENOWSECTIONPOST
// ADDSTAKENOWSECTIONPOST


const ADDSTAKENOWSECTIONPOST= createAsyncThunk(
  "addStakeNowSectionPost/addStakeNowSectionPost",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const addStakeNowSectionPostSlice = createSlice({
  name: "addStakeNowSectionPostSlice",
  initialState: {
    addStakeNowSectionPost: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfaddStakeNowSectionPost: (state) => {
        state.addStakeNowSectionPost.loading = false
        state.addStakeNowSectionPost.error = false
        state.addStakeNowSectionPost.data = []
        state.addStakeNowSectionPost.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ADDSTAKENOWSECTIONPOST.fulfilled, (state, action) => {
      state.addStakeNowSectionPost = {
        ...state.addStakeNowSectionPost,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDSTAKENOWSECTIONPOST.pending, (state, action) => {
      state.addStakeNowSectionPost = {
        ...state.addStakeNowSectionPost,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDSTAKENOWSECTIONPOST.rejected, (state, action) => {
      state.addStakeNowSectionPost = {
        ...state.addStakeNowSectionPost,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const addStakeNowSectionPostAction = {
    ADDSTAKENOWSECTIONPOST,
};

export { addStakeNowSectionPostAction };
export default addStakeNowSectionPostSlice.reducer;
export const {setInitialStateOfaddStakeNowSectionPost} = addStakeNowSectionPostSlice.actions
